/* ==========================================================================
   PanelVehicleRxjs > Client > vehicle
   ========================================================================== */

const SelectClient = require('@bluekiri/alexandria-contrib-components/components/select-rxjs/client/js');
const SelectActions = require('@bluekiri/alexandria-contrib-components/components/select-rxjs/client/js/store/actions');

const { addDimesions, destroyDimensions } = require('./dimesions');
const { addTrailer, destroyTrailer } = require('./trailer');

const configuration = require('../../config');

function updateVehicles(instance) {
    const { vehicle = {} } = instance.store.select('data');
    const { height, length, trailer } = vehicle;

    destroyTrailer(instance);
    destroyDimensions(instance, 'vehicle');
    destroyDimensions(instance, 'trailer');

    if (height && length) addDimesions(instance, 'vehicle');

    if (trailer) addTrailer(instance);
}

function initVehicles(instance) {
    const result = instance;
    const { reactions = {}, vehicleInput } = instance;

    /* Data Panel */
    const { panelType } = vehicleInput.store.select('data');
    const panelSelector = `[data-type="${panelType}"]`;

    result.vehicles = SelectClient(
        `${panelSelector} [data-component="SelectRxjs"][data-type="${configuration().type.vehicles}"]`
    );

    if (result.vehicles) {
        /* Extends reactions */
        result.reactions = {
            ...reactions,
            selectVehicle: result.vehicles.store.subscribe((state, action) => {
                if (action.type !== SelectActions.types.SELECT_OPTION) return;
                const { customProperties = {}, label, value } = result.vehicles.choices.getValue();
                const { height = undefined, length = undefined, trailer } = customProperties;

                /* Sync store */
                instance.actions.changeVehicle({
                    vehicle: { height, length, label, value, trailer },
                    vehicleHeight: height,
                    vehicleLength: length,
                    trailerHeight: undefined,
                    trailerLength: undefined,
                    trailer: false
                });
            })
        };

        /* Data */
        const { vehicle = {} } = instance.store.select('data');
        const { height, length, trailer } = vehicle;

        if (height && length) addDimesions(result, 'vehicle');
        if (trailer) addTrailer(result);
    }
}

function destroyVehicles(instance) {
    if (!instance.vehicles) return;
    const result = instance;

    /* Destroy */
    instance.vehicles.actions.destroy();
    destroyTrailer(instance);
    destroyDimensions(instance, 'vehicle');
    destroyDimensions(instance, 'trailer');

    /* unsubscribe */
    instance.reactions.selectVehicle.unsubscribe();

    /* Remove references */
    delete result.reactions.selectVehicle;
    delete result.vehicles;
}

module.exports = {
    updateVehicles,
    initVehicles,
    destroyVehicles
};
